import { Underline } from '@tiptap/extension-underline';

// Extend the underline extension to support the <ins> tag
export const CustomUnderline = Underline.extend({
  parseHTML() {
    const existingRule = this.parent?.() || [];
    return [...existingRule, { tag: 'ins' }];
  },
});
